import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { SmartToyOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuPersonasProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuPersonas = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuPersonasProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/personas"
        selected={pathname.startsWith('/live-chat/personas')}
      >
        <ListItemIcon>
          <SmartToyOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.personas',
          })}
        />
      </MenuItem>
    </div>
  )
}
